module.exports = __webpack_public_path__ + "img/icon17.f46559f1.png";